<template>
  <div class="shenyunjie-chart-dashboard" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import merge from "deepmerge";

export default {
  name: "YunJieChartDashboard",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizeDashboard);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizeDashboard() {
      let self = this;
      if (self.chart) {
        self.chart.resize();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        if (!self.chart) {
          let theme = self.theme || (this.$YunJie || {}).theme || "standard";
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark");
          } else {
            self.chart = echarts.init(document.getElementById(self.id));
          }
        }
        // 配置汇总
        let opt = {
          grid: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },
          series: [{
            type: "gauge",
            center: ["50%", "55%"],
            radius: "100%",
            progress: {
              show: true
            },
            min: self.min,
            max: self.max,
            detail: {
              valueAnimation: true,
              formatter: "{value}"
            },
            data: [{
              value: self.value,
              name: self.title
            }]
          }]
        };
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeDashboard);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    value() {
      this.init();
    },
    min() {
      this.init();
    },
    max() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-dashboard {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/dashboard.vue